const SEAT_REALTIME_KEYWORDS = [
    'seat_',
    'seat-',
    'seatbooking',
    'seat_booking',
    'seatbookings',
    'seat_seats',
    'seat_locations',
    'seat_checkin',
    'seat_auto_expire',
    'dat-cho-ngoi',
    'cho-ngoi',
    'coreworking',
];

export const isSeatRealtimeEvent = (payload) => {
    if (!payload) return false;
    let text = '';
    try {
        text = JSON.stringify(payload).toLowerCase();
    } catch (e) {
        text = String(payload).toLowerCase();
    }
    return SEAT_REALTIME_KEYWORDS.some(keyword => text.includes(keyword));
};
